(function(callback){
    // Check if jQuery is defined
    if (typeof jQuery === 'undefined') {
        // Load jQuery from CDN
        var script = document.createElement('script');
        script.src = 'https://code.jquery.com/jquery-3.6.0.min.js';
        script.type = 'text/javascript';
        script.onload = callback; // run code after jQuery loads
        document.getElementsByTagName('head')[0].appendChild(script);
    } else {
        // jQuery already loaded
        callback();
    }
})(function(){
    console.log('jQuery loaded');
    // SHA-256 helper (returns Promise)
    function sha256(value) {
        if (!value) return Promise.resolve(null);
        var msgBuffer = new TextEncoder().encode(value.trim().toLowerCase());
        return crypto.subtle.digest('SHA-256', msgBuffer).then(function(hashBuffer){
            var hashArray = Array.from(new Uint8Array(hashBuffer));
            return hashArray.map(function(b){ return b.toString(16).padStart(2,'0'); }).join('');
        });
    }

    // Normalize phone (digits only)
    function normalizePhone(phone) {
        return phone.replace(/\D/g, '');
    }

setTimeout(function(){
    var popup = $('#modal-signup-main-content');
    if (popup.length > 0) {

        
        var button = popup.find('.primary-action-button');

        // Disable button initially
        button.css({
            'opacity': 0.5,
            'pointer-events': 'none'
        });


        // Inject checkbox if not already added
        if($('#meta_request').length === 0){
            $('#modal-signup-custom-fields').append(`
                <label for="meta_request" style="display: flex; gap: 4px; align-items: center; cursor: pointer; color: #fff;">
                    <input type="checkbox" id="meta_request" name="meta_request" value="I agree to the terms." required>
                    I agree to the terms. *
                </label>
            `);
        }

        // Fire Pixel when checkbox changes
        $(document).on('change', '#meta_request', function(){
            var checkbox = $(this).is(':checked');
            if(!checkbox) return; // do nothing if unchecked

            var email = popup.find('input[type="email"]').val() || '';
            var phone = (popup.find('input[type="tel"]').val() || '').replace(/\D/g,'');
            var name = popup.find('input[name="first_name"]').val() || '';

            // Only fire Pixel if name and email/phone exist
            if(email.trim() && phone.trim() && name.trim()){
                sha256(email).then(function(hashedEmail){
                    sha256(phone).then(function(hashedPhone){
                        fbq('track','Lead',{
                            em: hashedEmail,
                            ph: hashedPhone,
                            fn: name
                        });
                        console.log('Lead fired:', hashedEmail, hashedPhone, name);
                    });
                });
                button.css({
                    'opacity': 1,
                    'pointer-events': 'auto'
                });
            } else {
                console.log('Checkbox checked but some fields are empty, Pixel not fired');
            }
        });
    }
},1000);

});

async function valHelmet() {
  console.log('validate function');

  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();

    // ONLY product IDs (test mode) 
    const freeHelmetProducts = [
      7582610194608
    ];

    const hasLimitedBike = cart.items.some(item =>
      item.product_title.toLowerCase().includes('limited edition')
    );

    if (!hasLimitedBike) {
      const updates = {};

      cart.items.forEach(item => {
        console.log('PRODUCT TITLE:', item.product_title);

        if (freeHelmetProducts.includes(item.product_id)) {
          updates[item.key] = 0; // remove helmet
        }
      });

      if (Object.keys(updates).length > 0) {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ updates })
        });

        console.log('Helmet removed (test mode)');
      }
    }

  } catch (err) {
    console.error('Helmet validation error:', err);
  }
}

async function validateHelmet() {
  // Disabled 2026-08-21: free-helmet enforcement is handled by the "FREE Smart Helmet" BXGY automatic discount and the "$0.00 Total" checkout rule. The 'limited edition' title check removed helmets from 2025-gen orders.
  return;
}

document.addEventListener('submit', async function(e) {
  if (e.target.matches('form[action=\"/cart\"]')) {
    e.preventDefault();
    const form = e.target;

    // Run validation (removes helmet if needed)
    await validateHelmet();

    const res = await fetch('/cart.js');
    const cart = await res.json();

    if (cart.item_count > 0) {
      // ✅ Still has items → proceed to checkout
        window.location.href = '/checkout';
    } else {
      // 🚫 Only helmet was in cart → block checkout
      location.reload();
    }

    // e.target.submit();
  }
});

document.addEventListener('DOMContentLoaded', async () => {
  await validateHelmet();
});